import { render, staticRenderFns } from "./LeftCard1.vue?vue&type=template&id=47b62c20&scoped=true&"
import script from "./LeftCard1.vue?vue&type=script&lang=js&"
export * from "./LeftCard1.vue?vue&type=script&lang=js&"
import style0 from "./LeftCard1.vue?vue&type=style&index=0&id=47b62c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b62c20",
  null
  
)

export default component.exports